import React from 'react';
import type { MenuProps } from 'antd';
import { Layout, Menu, theme } from 'antd';
import styles from './Main.module.less'
import { Outlet, useNavigate } from 'react-router-dom';

const { Header, Content, Footer, Sider } = Layout;

const items: MenuProps['items'] = [
    {
        key: '2',
        label: '表格',
        children: [
            {
                key: '/example/slickgrid',
                label: '基本表格',
            },
            {
                key: '/example/edit-slickgrid',
                label: '实时编辑',
            },
            {
                key: '/example/treeSlickgrid',
                label: '树形表格',
            },
            {
                key: '/example/lazySlickgrid',
                label: '按需加载',
            },
            {
                key: '/example/rowGroup',
                label: '行合并',
            },
            {
                key: '/example/multiHeader',
                label: '多级列头',
            },
        ],
    },
    {
        key: '1',
        label: 'ui组件',
        children: [
            {
                key: '/example/search',
                label: '基本搜索',
            },
            {
                key: '/example/baseUniver',
                label: '基本Univer',
            },
            {
                key: '/example/input-range',
                label: '范围输入框',
            },
            {
                key: '/example/datasource-select',
                label: '数据源下拉框',
            },
        ],
    },
    {
        key: '3',
        label: 'hooks',
        children: [
            {
                key: '/example/hearbeat',
                label: '心跳检测',
            },
        ],
    },
    {
        key: '4',
        label: '测试',
        children: [
            {
                key: '/example/react-query',
                label: 'react-query',
            },
            {
                key: '/example/tree-check',
                label: '树勾选',
            },


        ],
    },
]

const itemsKeys = items.map(i => i.key) as any[]

const App: React.FC = () => {
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const navigate = useNavigate()

    const handleMenuClick = ({ key }) => {
        console.log(key)
        navigate(key)
    }

    return (
        <Layout hasSider>
            <Sider className={styles['slider']}>
                <div className={styles['slider_title']} >
                    Playground
                </div>
                <Menu onClick={handleMenuClick}
                    theme="dark"
                    mode="inline"
                    defaultOpenKeys={itemsKeys}
                    defaultSelectedKeys={['1']}
                    items={items} />
            </Sider>
            <Layout style={{ marginInlineStart: 200, background: '#fff' }}>
                {/* <Header style={{ padding: 0, background: colorBgContainer }} /> */}
                <Content className={styles.content} >
                    <div
                        style={{
                            padding: 24,
                            textAlign: 'center',
                            // background: colorBgContainer,
                            borderRadius: borderRadiusLG,
                        }}
                    >
                        <Outlet />
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default App;